import React, { useState } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles'
import { Box, Button, IconButton, Typography } from '@material-ui/core'
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import colors from '../CustomizedUIs/Colors'
import { Add } from '@material-ui/icons'
import icDelete from '../assets/icons/primary-blue-bin.png'
import EditPopUp from './editPopup'
import icArrowUp from '../assets/icons/white-arrow-up.png';
import icArrowDown from '../assets/icons/white-arrow-down.png';
import Search from '../search'
import Snackbar from '../common/snackbar';
import { useLocation } from 'react-router';


const useStyles = makeStyles(theme => ({

    tableSortLabel: {
        color: 'theme.palette.common.white',
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    }
    ,
    icons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 7,
        cursor: 'pointer'
    },
    icon: {
        width: 9,
        height: 9
    },
    textbtnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    borderDelete: {
        borderRadius: '12px',
        backgroundColor: '#e5f1f8',
    },
    textEdit: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        ctextEdolor: '#ffffff',
        padding: '5px 8px 5px 8px'
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }
}));

const Groups = () => {
    const location = useLocation()
    const dataProvider = useDataProvider()
    const classes = useStyles()
    const translate = useTranslate()
    const [data, setData] = useState([])
    const [dataFilter, setDataFilter] = useState([])
    const [filter, setFilter] = useState('')
    const [click, SetClick] = useState(false)
    const { permissions, loaded } = usePermissions();
    const [showSnackbar, setShowSnackbar] = useState({
        status: false,
        name: '',
        message: ''
    })
    const [openDialog, setOpenDialog] = useState({
        data: null,
        status: false
    })
    const [openConfirmDialog, setOpenConfirmDialog] = useState({
        status: false,
        index: -1
    })
    const [loading, setLoading] = useState(false)
    const theme = useTheme()

    const getList = () => {
        setLoading(true)
        dataProvider('GET_LIST', "channels/findgroup", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setData(data);
                setDataFilter(data)
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            })
    }
    React.useEffect(() => {
        getList()

        // if (location.state && location.state.open) {
        //     setShowSnackbar(true);
        //     setTimeout(() => {
        //         setShowSnackbar(false);
        //     }, 6000);
        // }

    }, [])


    const submitFilter = () => {
        setDataFilter(data.filter(item => item.name.toUpperCase().includes(filter.toUpperCase())))
    }

    const handleOpenDialog = () => {
        setOpenDialog({
            data: null,
            status: true
        })
    }

    const openEditDialog = (item) => {
        setOpenDialog({
            data: item,
            status: true
        })
    }

    const handleClose = () => {
        setOpenDialog({
            data: null,
            status: false
        })
    }


    const handleOnDelete = () => {
        if (openConfirmDialog.index > -1) {
            dataProvider('DELETE', "channels/deletegroup", {
                id: data[openConfirmDialog.index].id
            })
                .then(() => {
                    getList()
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
                .catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
        }

    }
    const onClick = () => {
        setDataFilter(dataFilter.reverse())
        SetClick(!click)
    }

    if (loading || !loaded) return <Loading />
    return (
        <Box width='100%' display='flex' justifyContent='center'>
            <Box width='60%' mt={8}>
                <Box width='100%' display='flex' justifyContent='flex-end'>
                    <Snackbar
                        show={showSnackbar.status}
                        boldText={showSnackbar.name}
                        message={showSnackbar.message}
                        onClose={() => setShowSnackbar({
                            status: false,
                            name: '',
                            message: ''
                        })}
                    />
                </Box>
                <Box width='100%' display='flex' alignItems='center'>
                    <Box flexGrow={1} display="flex" flexDirection="row" alignItems="center">
                        <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{translate(`pos.channels.groupChannel`)}</Typography>
                        {
                            dataFilter.length > 0 ? <Typography className={classes.subText}>({dataFilter.length})</Typography>
                                : <Typography className={classes.subText}>(0)</Typography>
                        }
                    </Box>
                    <Search
                        placeholder={'Group'}
                        onChangeText={setFilter}
                        getList={submitFilter}
                    />
                    {
                        permissions.functionAction.find(value => value.function === 'Channels and programs' && value.isUpdate) &&
                        <Box ml={4}>
                            <Button variant='contained' color='primary' onClick={handleOpenDialog}>
                                <Typography className={classes.textbtnCreate}>{translate(`pos.channels.createNewGroup`)}</Typography>

                                <Add />
                            </Button>

                        </Box>
                    }

                </Box>
                <Box>
                    <Box display='flex' px={3} py={2} mt={1} bgcolor={theme.palette.primary.main}>
                        <Box flexGrow={1} display='flex' alignItems='center'>
                            <Typography
                                style={{ cursor: 'pointer', color: 'white', fontSize: 13 }}
                                variant='body1'>
                                Name
                            </Typography>
                            <div className={classes.icons}>
                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} onClick={onClick} style={{ opacity: click === true ? 0 : 1 }} />
                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click === false ? 0 : 1 }} onClick={onClick} />
                            </div>
                        </Box>
                    </Box>
                    <Box height='60vh' style={{ overflow: 'auto' }}>
                        {
                            dataFilter.map((item, index) => (
                                <Box key={'channel' + index} display='flex' px={3} py={2} mt={1} bgcolor='white'>
                                    <Box flexGrow={1} display='flex' alignItems='center'>
                                        <Typography
                                            style={{ cursor: 'pointer', fontSize: '13px' }}
                                            color='primary'
                                            variant='body1'>
                                            <b>{item.name}</b>
                                        </Typography>
                                    </Box>
                                    {
                                        permissions.functionAction.find(value => value.function === 'Channels and programs' && value.isUpdate) &&
                                        <Box display='flex' justifyContent='flex-end' alignItems='center'>
                                            <Box mr={1}>
                                                <Button size='small'
                                                    onClick={() => openEditDialog(item)} variant='contained' color='primary'>
                                                    <Typography className={classes.textEdit} style={{ padding: '8px' }} >{translate(`pos.common.edit`)}</Typography>
                                                </Button>
                                            </Box>
                                            <IconButton
                                                style={{ marginLeft: '1em', padding: '10px' }}
                                                className={classes.borderDelete}
                                                size='small'
                                                onClick={() => {
                                                    setOpenConfirmDialog({
                                                        status: true,
                                                        index: index
                                                    })
                                                }}
                                            >
                                                <img src={icDelete} width={15} height={15} />
                                            </IconButton>

                                        </Box>
                                    }

                                </Box>
                            ))
                        }
                    </Box>


                </Box>
            </Box>
            <EditPopUp
                getList={getList}
                data={data}
                setData={setData}
                openDialog={openDialog}
                onClose={handleClose}
                setShowSnackbar={setShowSnackbar}
            />
            <ConfirmDialog
                open={openConfirmDialog.status}
                handleClose={() => { setOpenConfirmDialog({ status: false, index: -1 }) }}
                handleConfirm={handleOnDelete}
                ContentText={translate('pos.user.contentDelete')}
                Tittle={translate('pos.channels.deleteGroupChannel')} />
        </Box>
    )
}
export default Groups